<template>
  <j-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item :label="$t('设备')" prop="deviceId">
              <!-- 行内录入:设备锁定不可改 -->
              <span v-if="lockDevice" class="lock-device">
                {{ model.deviceName }}（{{ model.deviceId }}）
              </span>
              <!-- 新增:远程搜索选择设备 -->
              <a-select
                v-else
                v-model="model.deviceId"
                show-search
                :placeholder="$t('请输入设备名称搜索')"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                allow-clear
                @search="handleDeviceSearch"
                @change="handleDeviceChange">
                <a-select-option v-for="d in deviceOptions" :key="d.deviceId" :value="d.deviceId">
                  {{ d.deviceName }}（{{ d.deviceId }}）
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('安装位置')">
              <span>{{ model.deviceLocation || '--' }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('上报时间')" prop="sysTime">
              <a-date-picker
                v-model="model.sysTime"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                style="width: 100%"
                :placeholder="$t('选择上报时间')" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-divider orientation="left">{{ $t('水质指标') }}</a-divider>
        <a-row :gutter="24">
          <a-col v-for="item in indicatorList" :key="item.key" :span="12">
            <a-form-model-item :label="$t(item.title)" :label-col="{ span: 11 }" :wrapper-col="{ span: 13 }">
              <a-input-number
                v-model="model[item.key]"
                :placeholder="$t('请输入') + $t(item.title)"
                :step="0.001"
                style="width: 100%" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import dayjs from 'dayjs'

export default {
  name: 'WaterQualityManualAddModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      lockDevice: false,
      model: {},
      deviceOptions: [],
      // 11 项指标:key 为提交给后端的字段名(对应 dataIndex 去掉 -Rtd),title 与列表列一致
      indicatorList: [
        { key: 'w01010Rtd', title: this.$t('温度值(℃)') },
        { key: 'w01001Rtd', title: this.$t('PH值') },
        { key: 'w01002Rtd', title: this.$t('色度') },
        { key: 'w01003Rtd', title: this.$t('浑浊度(NTU)') },
        { key: 'w01006Rtd', title: this.$t('溶解性总固体(mg/L)') },
        { key: 'w10000Rtd', title: this.$t('硬度(mg/L)') },
        { key: 'w10001Rtd', title: 'ORP(mv)' },
        { key: 'w21022Rtd', title: this.$t('氯化物(mg/L)') },
        { key: 'w21024Rtd', title: this.$t('余氯(mg/L)') },
        { key: 'w21038Rtd', title: this.$t('硫酸盐(mg/L)') },
        { key: 'w01014Rtd', title: this.$t('电导率(μS/cm)') }
      ],
      url: {
        deviceList: '/jeecg-charge/wq/meterDeviceBase/list',
        add: '/jeecg-charge/part/partWaterQualityLastRecord/manualAdd'
      }
    }
  },
  computed: {
    title() {
      return this.$t('手动录入')
    },
    validatorRules() {
      return {
        deviceId: [{ required: true, message: this.$t('请选择设备'), trigger: 'change' }],
        sysTime: [{ required: true, message: this.$t('请选择上报时间'), trigger: 'change' }]
      }
    }
  },
  methods: {
    /**
     * 打开弹窗。
     * @param record 行内录入时传入 { meterId, deviceName, deviceLocation };新增时传 {}
     */
    open(record = {}) {
      this.visible = true
      this.lockDevice = !!record.meterId
      this.deviceOptions = []
      this.model = {
        deviceId: record.meterId || undefined,
        deviceName: record.deviceName || '',
        deviceLocation: record.deviceLocation || '',
        sysTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
      }
      // 行内录入时把当前设备塞进下拉,保证展示
      if (this.lockDevice) {
        this.deviceOptions = [{ deviceId: record.meterId, deviceName: record.deviceName }]
      } else {
        // 新增:打开时默认加载全部水质设备
        this.handleDeviceSearch('')
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleDeviceSearch(value) {
      // value 为空:加载全部水质设备;非空:模糊搜索(后端需 *关键词* 才走 LIKE)
      const params = {
        deviceType: 'WaterQuality',
        pageNo: 1,
        pageSize: 50
      }
      if (value) {
        params.deviceName = '*' + value + '*'
      }
      getAction(this.url.deviceList, params).then(res => {
        if (res.success) {
          this.deviceOptions = res.result.records || []
        }
      })
    },
    handleDeviceChange(value) {
      const dev = this.deviceOptions.find(d => d.deviceId === value)
      this.model.deviceName = dev ? dev.deviceName : ''
      this.model.deviceLocation = dev ? dev.deviceLocation : ''
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      // 至少录入一项指标
      const hasIndicator = this.indicatorList.some(item =>
        this.model[item.key] !== undefined && this.model[item.key] !== null && this.model[item.key] !== ''
      )
      if (!hasIndicator) {
        this.$message.warning(this.$t('请至少录入一项指标值'))
        return
      }
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.confirmLoading = true
        // 组装提交体:deviceId、sysTime + 非空指标(后端用 @JsonProperty("xxx-Rtd") 接收)
        const params = {
          deviceId: this.model.deviceId,
          sysTime: this.model.sysTime
        }
        this.indicatorList.forEach(item => {
          const val = this.model[item.key]
          if (val !== undefined && val !== null && val !== '') {
            // key 形如 w01001Rtd -> 提交字段名 w01001-Rtd
            params[this.toDashKey(item.key)] = val
          }
        })
        postAction(this.url.add, params).then(res => {
          if (res.success) {
            this.$message.success(res.message || this.$t('录入成功'))
            this.$emit('ok')
            this.visible = false
          } else {
            this.$message.warning(res.message || this.$t('录入失败'))
          }
        }).finally(() => {
          this.confirmLoading = false
        })
      })
    },
    /** w01001Rtd -> w01001-Rtd */
    toDashKey(key) {
      return key.replace(/Rtd$/, '-Rtd')
    }
  }
}
</script>
<style scoped>
.lock-device {
  display: inline-block;
  line-height: 32px;
}
</style>
